export default {
    props: {
        // Form values
        modelValue: {
            type: Object,
            required: true,
        },
        settings: {
            type: [Array, Object],
            required: false,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue', 'update-rules'],
};
